import React, { ReactNode } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../../components/ui/card';
import { cn } from '../../../lib/utils';

interface SectionCardProps {
  id?: string;
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

export const SectionCard: React.FC<SectionCardProps> = ({
  id,
  title,
  subtitle,
  icon,
  action,
  children,
  className = '',
}) => {
  return (
    <Card id={id} className={cn('bg-white rounded-xl border border-slate-100 shadow-xs overflow-hidden mb-3.5 transition-all hover:shadow-sm', className)}>
      <CardHeader className="px-4 py-3 sm:px-5 sm:py-3.5 border-b border-slate-100 flex flex-row items-center justify-between space-y-0 bg-gradient-to-b from-white to-slate-50/30">
        <div>
          <CardTitle className="text-sm sm:text-base font-bold text-slate-900 flex items-center gap-2 tracking-tight m-0">
            {icon && <span className="text-[#1AA7DE] flex items-center">{icon}</span>}
            {title}
          </CardTitle>
          {subtitle && <CardDescription className="text-xs text-slate-500 font-medium mt-0.5 mb-0">{subtitle}</CardDescription>}
        </div>
        {action && <div>{action}</div>}
      </CardHeader>
      <CardContent className="p-4 sm:p-4.5">
        {children}
      </CardContent>
    </Card>
  );
};

export default SectionCard;
